import { openobserveLogs } from '@openobserve/browser-logs';
import { openobserveRum } from '@openobserve/browser-rum';

let initialized = false;

/**
 * Initialize OpenObserve RUM and browser logs SDK for money-frontend.
 * Reads config from VITE_ env vars — no-ops when client token is absent.
 */
export function initOpenObserve(deploymentEnv: string): void {
  const clientToken = import.meta.env.VITE_OPENOBSERVE_CLIENT_TOKEN as
    | string
    | undefined;
  const site = import.meta.env.VITE_OPENOBSERVE_SITE as string | undefined;
  const organizationIdentifier =
    (import.meta.env.VITE_OPENOBSERVE_ORG as string) || 'default';
  const service = (import.meta.env.VITE_APP_NAME as string) || 'money-frontend';
  const version = (import.meta.env.VITE_VERSION as string) || '0.0.1';
  const insecureHTTP =
    (import.meta.env.VITE_OPENOBSERVE_INSECURE as string) === 'true';
  const replaySampleRate = Number(
    import.meta.env.VITE_OPENOBSERVE_REPLAY_SAMPLE_RATE ?? 0,
  );

  if (!clientToken || !site) {
    return;
  }

  if (initialized) {
    return;
  }
  initialized = true;

  openobserveRum.init({
    applicationId: service,
    clientToken,
    site,
    organizationIdentifier,
    service,
    env: deploymentEnv,
    version,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    apiVersion: 'v1',
    insecureHTTP,
    defaultPrivacyLevel: 'mask-user-input',
    sessionSampleRate: 100,
    sessionReplaySampleRate: replaySampleRate,
  });

  openobserveLogs.init({
    clientToken,
    site,
    organizationIdentifier,
    service,
    env: deploymentEnv,
    version,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['log', 'info', 'warn', 'error'],
    insecureHTTP,
    apiVersion: 'v1',
  });

  if (replaySampleRate > 0) {
    openobserveRum.startSessionReplayRecording();
  }
}
